<template>
  <div class="configManage">
    <div class="status">
      <el-menu
      :default-active="activeIndex"
      mode="horizontal"
      @select="handleSelect"
      text-color="#fff"
      active-text-color="#359186">
        <el-menu-item class="hItem" index="状态"> 状态</el-menu-item>
        <el-menu-item index="全部">全部(<span>{{allNum}}</span>)</el-menu-item>
        <el-menu-item index="待发送">待发送(<span>{{dataNum}}</span>)</el-menu-item>
<!--        <el-menu-item index="波形不更新">波形不更新(<span>{{waveNum}}</span>)</el-menu-item>-->
        <el-menu-item index="发送成功">发送成功(<span>{{alarmNum}}</span>)</el-menu-item>
        <el-menu-item index="发送失败">发送失败(<span>{{equipNum}}</span>)</el-menu-item>
<!--        <el-menu-item index="节点异常">节点异常(<span>{{nodeNum}}</span>)</el-menu-item>-->
<!--        <el-menu-item index="电池电量报警">电池电量报警(<span>{{batteryNum}}</span>)</el-menu-item>-->
      </el-menu>
      <el-button type="primary"  size="small" @click="outExcel">导出EXCEL</el-button>

    </div>
<!--    <div class="choose">-->
<!--      <span>选择用户：</span>-->
<!--      <el-select v-model="userSelect" size="mini" @change="handleClick">-->
<!--        <el-option-->
<!--        v-for="item in userOption"-->
<!--        :key="item.value"-->
<!--        :value="item.value"-->
<!--        :label="item.label">-->
<!--        </el-option>-->
<!--      </el-select>-->
<!--      <span>邮件地址：</span>-->
<!--      <el-select v-model="mailSelect" size="mini" @change="handleClick">-->
<!--        <el-option-->
<!--        v-for="item in mailOption"-->
<!--        :key="item.value"-->
<!--        :value="item.value"-->
<!--        :label="item.label">-->
<!--        </el-option>-->
<!--      </el-select>-->
<!--      <span>选择服务器：</span>-->
<!--      <el-select v-model="serverSelect" size="mini" @change="handleClick">-->
<!--        <el-option-->
<!--        v-for="item in serverOption"-->
<!--        :key="item.value"-->
<!--        :value="item.value"-->
<!--        :label="item.label">-->
<!--        </el-option>-->
<!--      </el-select>-->
      <!-- <el-button size="mini" @click="handleClick">刷新</el-button> -->
<!--    </div>-->
    <div class="search">
        <span class="wordFind">查找：</span>
        <el-input class="find" v-model="search" size="mini" placeholder="请输入关键字"></el-input>
        <span class="wordPage">选择每页显示的行数：</span>
        <el-select v-model="value" class="page" size="mini">
          <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
          </el-option>
        </el-select>
    </div>
    <div class="statusTable">
      <!-- el-tabel设置height就会出现滚动条且表头跟着滚动条移动 -->
      <el-table
        :data="filterTable.slice((currentPage - 1) * value, currentPage * value)"
        height="100%"
        :default-sort = "{prop: 'information', order: 'descending'}">
        <el-table-column
        type="index"
        label="序号"
        >

        </el-table-column>
        <el-table-column
            prop="mail"
            label="接收者"
            sortable>
        </el-table-column>
        <el-table-column
        prop="status"
        label="邮件标题"
        sortable>
        </el-table-column>
<!--        <el-table-column-->
<!--        prop="user"-->
<!--        label="用户"-->
<!--        sortable>-->
<!--        </el-table-column>-->

<!--        <el-table-column-->
<!--        prop="content"-->
<!--        label="邮件内容"-->
<!--        sortable>-->
<!--        </el-table-column>-->
        <el-table-column
        prop="information"
        label="发送时间"
        sortable>
        </el-table-column>
        <el-table-column
            label="发送状态"
            prop="sendStatus"
            width="220px">
        </el-table-column>
<!--        <el-table-column-->
<!--        label="发送状态"-->
<!--        prop="sendStatus"-->
<!--        width="220px">-->
<!--        <template #default="scope" >-->
<!--          <el-button type="danger" size="mini" @click="handleDel(scope.$index, scope.row)"-->
<!--            >删除</el-button-->
<!--          >-->
<!--        </template>-->
<!--      </el-table-column>-->
      </el-table>
    </div>
    <el-pagination
      layout="prev, pager, next"
      :total="(filterTable.length / value) * 10"
      @current-change="handleCurrentChange"
      :current-page="currentPage">
    </el-pagination>
<!--    <el-button size="mini" class="rule" @click="dialogFormVisible = true">新增规则</el-button>-->
    <el-dialog v-model="dialogFormVisible" title="设置" >
      <el-form>
        <el-form-item label="设置故障类型：">
          <el-select v-model="typeVm" >
            <el-option
            v-for="item in typeOp"
            :key="item.value"
            :label="item.label"
            :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设置接收邮箱：">
          <el-input v-model="mail" placeholder="输入要发送的邮箱" class="inputMail">
          </el-input>
        </el-form-item>
        <el-form-item label="设置报警间隔：" v-show="typeVm != '设备报警' && typeVm != '电池电量报警'">
          <el-time-picker
            v-model="timePick"
            format="HH:mm"
            placeholder="选择时间">
          </el-time-picker>
        </el-form-item>
        <el-form-item label="设置电池电量：" v-show="typeVm == '电池电量报警'" class="slider">
          <el-slider v-model="barryValue"> </el-slider>
          <span>{{barryValue}}%</span>
        </el-form-item>
        <el-form-item label="发送端服务器：" >
          <el-select v-model="serverVm">
            <el-option
            v-for="item in serverOp"
            :key="item.value"
            :label="item.label"
            :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设置登录用户：" class="inputUser">
          <el-input v-model="user" placeholder="输入用户名">
          </el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="handleAdd">
            确认</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {ref, onBeforeMount, computed, watch} from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import {useStore} from 'vuex'
import {export_json_to_excel} from "../components/ExportFiles/Export2Excel";
import {useRoute} from 'vue-router'
import axios from 'axios'
export default {
  name: 'configManage',
  setup(props, ctx){
    let activeIndex = ref('全部');
    let tableData = ref([]);
    let tmpTableData = ref([]);
    let search = ref('');
    let value = ref(10);
    let totalNum = ref(0);
    let currentPage = ref(1);
    let serverVm = ref('1号服务器');
    let typeVm = ref('数据不更新');
    let mail = ref('');
    let user = ref('');
    let OptionUser = ref([{value: '全部', label: '全部'}]);
    let OptionMail = ref([{value: '全部', label: '全部'}]);
    let OptionServer = ref([{value: '全部', label: '全部'}]);
    let borderColor1 = ref('#dcdfe6');
    let borderColor2 = ref('#dcdfe6');
    let userSelect = ref('全部');
    let mailSelect = ref('全部');
    let serverSelect = ref('全部');
    let barryValue = ref(0);
    let formatJson = (filterVal, jsonData) => {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
    let outExcel = () => {
      //require.ensure([], () => {

      const tHeader = [ '接收者', '邮件标题', '邮件内容', '发送时间', '发送状态'  ];
      const filterVal = [  'mail', 'status', 'content', 'information', 'emailStatus'];
      const list = filterTable.value;
      const data =  formatJson(filterVal, list);
      export_json_to_excel(tHeader, data, '邮件发送列表  导出时间 : '+timestampToTime(new Date().valueOf()) );
      // })
    }
    let timePick = ref(new Date(2021, 6, 15, 2, 0));
    let options = ref([
      {
        value: 10,
        label: 10
      },
      {
        value: 15,
        label: 15
      },
      {
        value: 25,
        label: 25
      },
      {
        value: 50,
        label: 50
      },
      {
        value: 100,
        label: 100
      }
    ])
    let typeOp = ref([
      {
        value: '数据不更新',
        label: '数据不更新'
      },
      // {
      //   value: '波形不更新',
      //   label: '波形不更新'
      // },
      {
        value: '报警数据无波形',
        label: '报警数据无波形'
      },
      {
        value: '设备报警',
        label: '设备报警'
      },
      // {
      //   value: '节点异常',
      //   label: '节点异常'
      // },
      {
        value: '电池电量报警',
        label: '电池电量报警'
      },
    ])
    let serverOp = ref([
      {
        value: '1号服务器',
        label: '1号服务器'
      },
      {
        value: '2号服务器',
        label: '2号服务器'
      }
    ])
    let store = useStore();
    let route = useRoute();
    const dialogFormVisible = ref(false);
    watch(() => store.state.nodeLable, () => {
      // console.log('点击了设备树');
      // console.log(route.path);
      if (route.path == '/ConfigManage') {
        return ;
      }
      let items = tmpTableData.value;
      let items1;
      // console.log(activeIndex.value);
      if (activeIndex.value == '状态' || activeIndex.value == '全部') {
        items1 = items.filter((item) => {
          return Object.keys(item).some((key1) => {
            return item[key1] == store.state.nodeLable;
          })
        })
      } else {
        items1 = items.filter((item) => {
        return Object.keys(item).some((key1) => {
          return item[key1] == store.state.nodeLable;
        }) && Object.keys(item).some((key1) => {
          return item[key1] == activeIndex.value;
        })
      })
      }
      tableData.value = items1;
    })
    let handleSelect = (key, keyPath) => {
      activeIndex.value = key;
      let items = tmpTableData.value;
      let items1;
      if (key != '状态') {
        if (key == '全部') {
          items1 = items.filter((item) => {
            return (userSelect.value == '全部' ? true : item['user'] == userSelect.value ) &&
        (mailSelect.value == '全部' ? true : item['mail'] == mailSelect.value) &&
        (serverSelect.value == '全部' ? true : item['server'] == serverSelect.value)
          });
        } else {
            items1 = items.filter((item) => {
            return (item['sendStatus'] == key||(item['sendStatus'] == '已发送'&&key == '发送成功')) && (userSelect.value == '全部' ? true : item['user'] == userSelect.value ) &&
        (mailSelect.value == '全部' ? true : item['mail'] == mailSelect.value) &&
        (serverSelect.value == '全部' ? true : item['server'] == serverSelect.value);
          })
        }
      }
      tableData.value = items1;
      // console.log('切换状态', activeIndex.value);
    }
    let handleClick = (() => {
      let items = tmpTableData.value;
      // console.log('用户',tmpTableData.value[0]['user'], tmpTableData.value[0]['user'] == userSelect.value, typeof(userSelect.value));
      let items1 = items.filter((item) => {
        return (userSelect.value == '全部' ? true : item['user'] == userSelect.value ) &&
        (mailSelect.value == '全部' ? true : item['mail'] == mailSelect.value) &&
        (serverSelect.value == '全部' ? true : item['server'] == serverSelect.value) && (activeIndex.value == '全部' ? true : activeIndex.value == item['status']);
      })
      tableData.value = items1;
    })
    let timestampToTime = (timestamp) => {
      let date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '年';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月';
      let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' 日 ';
      let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      //let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()) + '.';
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()) ;

      let ms = (timestamp % 1000).toString()
      while (ms.length < 3) {
        ms = '0' + ms
      }
      // return Y + M + D + h + m + s + ms;
      return Y + M + D + h + m + s ;
    }
    let getTableData = (() => {
      console.log('生命周期')
      axios.get('/api1/email').then(res => {
        if (res.data.code == 200) {
          let data = res.data.data;

          for(let i=0;i<data.length;i++){
            data[i].mail = data[i].recipient;

            data[i].sendStatus = data[i].status;
            data[i].status = data[i].title;
            data[i].information = timestampToTime(data[i].sendTime);
            // data[i].mail=data[i].mailAddress  ;
            // data[i].status = data[i].remark;
            // data[i].user = data[i].addUserName;
            // data[i].information = data[i].accessInterval+'小时'
          }
          console.log(data);
          tableData.value = data;
          tmpTableData.value = data;
          totalNum.value = tableData.value.length;
          // let user = {}, mail = {}, server = {};
          // tmpTableData.value.some((item) => {
          //   console.log(item);
          //   if (!user[item['user']]) {
          //     OptionUser.value.push({
          //       value: item['user'],
          //       label: item['user']
          //     })
          //   }
          //   if (!mail[item['mail']]) {
          //     OptionMail.value.push({
          //       value: item['mail'],
          //       label: item['mail']
          //     })
          //   }
          //   if (!server[item['server']]) {
          //     OptionServer.value.push({
          //       value: item['server'],
          //       label: item['server']
          //     })
          //   }
          //   user[item['user']] = 1;
          //   mail[item['mail']] = 1;
          //   server[item['server']] = 1;
          // })

          // allNum.value = data.length;
          // console.log('长度',tableData.value.length);
          // console.log(data);
        }
      })
    })
    // onBeforeMount(()=>{
    //   getTableData()
    // })
    let handleCurrentChange = ((val) => {
      // console.log('当前页数', val);
      currentPage.value = val;
    })
    let handleAdd = (() => {
      // console.log('显示时间', timePick.value, /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(mail.value));
      if (!mail.value || !/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(mail.value)) {
        ElMessage.error('请输入正确的邮箱');
        borderColor1.value = 'red';
      } else if (!user.value) {
        ElMessage.error('请输入用户名');
        borderColor1.value = '#dcdfe6';
        borderColor2.value = 'red';
      } else {
        borderColor2.value = '#dcdfe6';
        dialogFormVisible.value = false;
        // console.log('增加的信息',typeVm.value, user.value, mail.value, serverVm.value, new Date(timePick.value).getHours(), new Date(timePick.value).getMinutes());
        let info = {
          'status': typeVm.value,
          'user': user.value,
          'mail': mail.value,
          'server': serverVm.value,
          // 'information': `${new Date(timePick.value).getHours()}小时${new Date(timePick.value).getMinutes()}分钟报警`
          'information':  new Date(timePick.value).getHours()
        }


        //     = new URLSearchParams();
        // param.append('remark',info.status);
        // param.append('addUserName',info.user);
        // param.append('accessInterval',info.information);
        // param.append('mailAddress',info.mail);
        // param.append('addTime',new Date().toString());
        // param.append('alarmName','空白');
        // param.append('apiUrl','api的URL');
        // param.append('apiName','api名字');
        let param = {
          'remark':info.status,
          'addUserName':info.user,
          'mailAddress':info.mail,
          'addTime':new Date().valueOf() ,
          'alarmName':'空白',
          'apiUrl':'api的URL'  ,
          'apiName':'api名字',
          'accessInterval':info.information

        }
        axios({
          method:"post",
          url:'/api1/alarm/insert',
          data:param,
        }).then( res => {
          info = param;
          tmpTableData.value.push(info);
          if (activeIndex.value != '全部' && activeIndex.value == typeVm.value) {
            tableData.value.push(info);
          }
          ElMessage({
            message: '添加成功',
            type: 'success',
          })
          getTableData();
        })




      }
    })
    let handleDel = ((index, row) => {
      ElMessageBox.confirm(
      '确定要删除吗?',
      '警告',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    ).then(() => {
        for (let item in tmpTableData.value) {
          if (tmpTableData.value[item] == row) {
              console.log('相应信息', row, tmpTableData.value[item]);

            tmpTableData.value.splice(item, 1);
            if (activeIndex.value != '全部')
            tableData.value.splice(index, 1)

            return       axios.get( '/api1/alarm/delete/'+row.id)
            break;
          }
        }

        // tableData.value.splice(index, 1)

      }).then( res =>{
        getTableData();
        ElMessage({
          type: 'success',
          message: '删除成功',
        })
      })

      // .catch(() => {
      //   ElMessage({
      //     type: 'info',
      //     message: '取消',
      //   })
      // })
      // console.log('相应信息', row, tmpTableData.value[0]);
      // for (let item in tmpTableData.value) {
      //   if (tmpTableData.value[item] == row) {
      //     console.log('wuwuwu');
      //     tmpTableData.value.splice(item, 1);
      //     break;
      //   }
      // }
      // tableData.value.splice(index, 1)
    })
    let userOption = computed(() => {
      let user = {};
      OptionUser.value = [
        {
          value: '全部',
          label: '全部'
        }
      ]
      tmpTableData.value.some((item) => {
        if (!user[item['user']]) {
          OptionUser.value.push({
            value: item['user'],
            label: item['user']
          })
        }
        user[item['user']] = 1;
      })
      return OptionUser.value;
    })
    let mailOption = computed(() => {
      let mail = {};
      OptionMail.value = [
        {
          value: '全部',
          label: '全部'
        }
      ]
      tmpTableData.value.some((item) => {
        if (!mail[item['mail']]) {
          OptionMail.value.push({
            value: item['mail'],
            label: item['mail']
          })
        }
        mail[item['mail']] = 1;
      })
      return OptionMail.value;
    })
    let serverOption = computed(() => {
      let server = {};
      OptionServer.value = [
        {
          value: '全部',
          label: '全部'
        }
      ]
      tmpTableData.value.some((item) => {
        if (!server[item['server']]) {
          OptionServer.value.push({
            value: item['server'],
            label: item['server']
          })
        }
        server[item['server']] = 1;
      })
      return OptionServer.value;
    })

    let allNum = computed(() => {
      return tmpTableData.value.filter((item) => {
        return Object.keys(item).some((key1) => {
            if (!search) {
              return true;
            }
            return String(item[key1])
            .toLowerCase()
            .match(search.value);
          }) && (userSelect.value == '全部' ? true : item['user'] == userSelect.value ) &&
        (mailSelect.value == '全部' ? true : item['mail'] == mailSelect.value) &&
        (serverSelect.value == '全部' ? true : item['server'] ==serverSelect.value)
      }).length;
    })
    let norNum = computed(() => {
      return tmpTableData.value.filter((item) => {
        return item['status'] == '正常' && Object.keys(item).some((key1) => {
            if (!search) {
              return true;
            }
            return String(item[key1])
            .toLowerCase()
            .match(search.value);
          }) && (userSelect.value == '全部' ? true : item['user'] == userSelect.value ) &&
        (mailSelect.value == '全部' ? true : item['mail'] == mailSelect.value) &&
        (serverSelect.value == '全部' ? true : item['server'] == serverSelect.value);
      }).length
    });
    let dataNum = computed(() => {
      return tmpTableData.value.filter((item) => {
        return item['sendStatus'].search( '待发送')!=-1 && Object.keys(item).some((key1) => {
            if (!search) {
              return true;
            }
            return String(item[key1])
            .toLowerCase()
            .match(search.value);
          }) && (userSelect.value == '全部' ? true : item['user'] == userSelect.value ) &&
        (mailSelect.value == '全部' ? true : item['mail'] == mailSelect.value) &&
        (serverSelect.value == '全部' ? true : item['server'] == serverSelect.value);
      }).length
    });
    let waveNum = computed(() => {
      return tmpTableData.value.filter((item) => {
        return item['status'] == '波形不更新' && Object.keys(item).some((key1) => {
            if (!search) {
              return true;
            }
            return String(item[key1])
            .toLowerCase()
            .match(search.value);
          }) && (userSelect.value == '全部' ? true : item['user'] == userSelect.value ) &&
        (mailSelect.value == '全部' ? true : item['mail'] == mailSelect.value) &&
        (serverSelect.value == '全部' ? true : item['server'] == serverSelect.value);
      }).length
    });
    let alarmNum = computed(() => {
      return tmpTableData.value.filter((item) => {
        return item['sendStatus'].search('发送成功')!=-1 && Object.keys(item).some((key1) => {
            if (!search) {
              return true;
            }
            return String(item[key1])
            .toLowerCase()
            .match(search.value);
          }) && (userSelect.value == '全部' ? true : item['user'] == userSelect.value ) &&
        (mailSelect.value == '全部' ? true : item['mail'] == mailSelect.value) &&
        (serverSelect.value == '全部' ? true : item['server'] == serverSelect.value);
      }).length
    });
    let equipNum = computed(() => {
      return tmpTableData.value.filter((item) => {
        return item['sendStatus'].search( '发送失败')!=-1 && Object.keys(item).some((key1) => {
            if (!search) {
              return true;
            }
            return String(item[key1])
            .toLowerCase()
            .match(search.value);
          }) && (userSelect.value == '全部' ? true : item['user'] == userSelect.value ) &&
        (mailSelect.value == '全部' ? true : item['mail'] == mailSelect.value) &&
        (serverSelect.value == '全部' ? true : item['server'] == serverSelect.value);
      }).length
    });
    let nodeNum = computed(() => {
      return tmpTableData.value.filter((item) => {
        return item['status'] == '节点异常' && Object.keys(item).some((key1) => {
            if (!search) {
              return true;
            }
            return String(item[key1])
            .toLowerCase()
            .match(search.value);
          }) && (userSelect.value == '全部' ? true : item['user'] == userSelect.value ) &&
        (mailSelect.value == '全部' ? true : item['mail'] == mailSelect.value) &&
        (serverSelect.value == '全部' ? true : item['server'] == serverSelect.value);
      }).length
    });
    let batteryNum = computed(() => {
      return tmpTableData.value.filter((item) => {
        return item['status'] == '电池电量报警' && Object.keys(item).some((key1) => {
            if (!search) {
              return true;
            }
            return String(item[key1])
            .toLowerCase()
            .match(search.value);
          }) && (userSelect.value == '全部' ? true : item['user'] == userSelect.value ) &&
        (mailSelect.value == '全部' ? true : item['mail'] == mailSelect.value) &&
        (serverSelect.value == '全部' ? true : item['server'] == serverSelect.value);
      }).length
    });
    let filterTable = computed(() => {
      let input = search.value && search.value.toLowerCase();
      let items = tableData.value;
      let items1;
      console.log(items1,'items1');
      if (input) {
        items1 = items.filter((item) => {
          return Object.keys(item).some((key1) => {
            return String(item[key1])
            .toLowerCase()
            .match(input);
          })
        })
      } else {
        items1 = items;
      }
      // items1.sort((a, b) => {
      //   return a.sendTime > b.sendTime
      // })
      return items1;
    })
    onBeforeMount(() => {
      console.log('生命周期')
      getTableData();
    })
    return {
      allNum,
      norNum,
      dataNum,
      waveNum,
      alarmNum,
      equipNum,
      nodeNum,
      batteryNum,
      activeIndex,
      tableData,
      search,
      options,
      value,
      totalNum,
      currentPage,
      filterTable,
      tmpTableData,
      dialogFormVisible,
      typeOp,
      serverOp,
      serverVm,
      typeVm,
      timePick,
      mail,
      user,
      borderColor1,
      borderColor2,
      OptionUser,
      OptionMail,
      OptionServer,
      userSelect,
      mailSelect,
      serverSelect,
      userOption,
      mailOption,
      serverOption,
      barryValue,
      handleSelect,
      getTableData,
      handleCurrentChange,
      handleDel,
      handleAdd,
      handleClick,
      outExcel
    }
  }
}
</script>

<style lang="scss">
  .configManage{
    // --borderColor: #dcdfe6;
    width: 100%;
    height: calc(100vh - 60px);
    margin-right: 10px;
    // margin-bottom: 10px;
    background-color: #303749;
    // background-color: #bfa;
    .status{
      height: 10%;
      background-color: #2c3242;
      margin-left: 10px;
      margin-right: 10px;
      margin-top: 10px;
      .el-menu{
        height: 100%;
        background-color: #2c3242;
        border-bottom: 0px;
        display: flex;
        align-items: center; //垂直居中
        // justify-content: center;
        .el-menu-item.hItem{
          font-size: 20px;
        }
        .el-menu-item{
          color: #fff;
          font-size: 13px;
          border-bottom: 0px;
        }
        .el-menu-item.is-active{
          background-color: #2c3242 !important;
          color: #359186;
          border-bottom: 0px;
        }
        .el-menu-item.hItem.is-active{
          background-color: #2c3242 !important;
          color: #fff !important;
          border-bottom: 0px;
        }
        .el-menu-item:hover{
          background-color: #2c3242 ;
          color: #359186;
        }
        .el-menu-item.hItem:hover{
          background-color: #2c3242;
          color: #fff;
        }
      }
      .el-button:hover{
        border-color: #42b983;
        color: #42b983;
      }
      .el-button{
        background-color: #2C3242;
        border-color: #fff;
        position: absolute;
        margin-top: -50px;
        right: 30px;
      }
    }
    .choose{
      height: 6%;
      margin: 0 10px;
      background-color: #2c3242;
      display: flex;
      align-items: center;
      span{
        font-size: 13px;
        color: #fff;
        margin-left: 10px;
      }
      .el-select .el-input {
        .el-input__inner{
          background-color: #2c3242;
          color: #fff;
          border: 1px #fff solid;
        }
      }
      .el-button{
        margin-left: 10px;
        background-color: #2c3242;
        span{
          margin: 0px;
        }
      }
    }
    .search{
      display: flex;
      margin: 0px 10px;
      position: relative;
      align-items: center;
      span{
        margin-top: 10px;
        font-size: 13px;
        color: #fff;
      }
      span.wordFind{
        margin-left: 5px;
      }
      .el-input{
        // margin-left: 10px;
        margin-top: 10px;
        width: 200px;
        .el-input__inner{
          background-color: #303749;
          color: #fff;
          border: 1px #fff solid;
        }
      }
      .el-input .el-input__inner.active{
        border: 1px red solid;
      }
      .el-select .el-input{
        width: 100px;
        .el-input__inner{
          text-align: center;
          border: 1px #fff solid;
        }
        .el-input__suffix, .el-input__suffix-inner{
          margin-top: 0px;
        }
      }
      span.wordPage{
        position: absolute;
        right: 100px;
      }
      .el-select.page{
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
    .statusTable{
      margin-left: 10px;
      margin-right: 10px;
      background-color: #2c3242;
      height: 66%;
      //去除表格最下面那条线
      .el-table::before{
        height: 0px;
      }
      .el-table{
        background-color: #2c3242;
        //去除表头下面那条线
        th.el-table__cell.is-leaf{
          border-bottom: 0px;
        }
        //设置排序图标的颜色
        // .descending .sort-caret.descending {
        //   border-top-color: #359186;
        // }
        // .ascending .sort-caret.ascending {
        //   border-bottom-color: #359186;
        // }
        .cell{
          text-align: center;
        }
        th{
          background-color: #2c3242;
          color: #fff;
          // border-right: 1px solid rgba(256, 256, 256, 0.5);
        }
        tr{
          background-color: #2c3242;
          color: #fff;
          td{
            border-bottom: 0px;
          }
        }
        tr:hover td{
          background-color: rgba(107, 199, 255, 0.98) !important;
        }
      }
    }
    .el-pagination{
      margin-top: 10px;
      display: flex;
      align-items: center; //垂直居中
      ul li{
        background-color: #303749;
        color: #fff;
      }
      ul li.active{
        color: #359186;
      }
      ul li:hover{
        color: #359186;
      }
      .btn-prev{
        background-color: #303749;
        .el-icon{
          color: #fff;
        }
        .el-icon:hover{
          color: #359186;
        }
      }
      .btn-next{
        background-color: #303749;
        .el-icon{
          color: #fff;
        }
        .el-icon:hover{
          color: #359186;
        }
      }
    }
    .rule{
      background-color: #303749;
      color: #fff;
    }

    .el-dialog{
      text-align: left;
      width: 70vh;
      // height: 60vh;
      .el-input{
        width: 222px;
        .el-input__inner:hover{
          border: 1px solid #409eff;
        }
      }
      .inputMail .el-input__inner{
        border: 1px v-bind(borderColor1) solid;
      }
      // .inputMail .el-input__inner:hover{
      //   border: 1px #c0c4cc solid;
      // }
      .inputUser .el-input__inner{
        border: 1px v-bind(borderColor2) solid;
      }
      // .inputUser .el-input__inner:hover{
      //   border: 1px #c0c4cc solid;
      // }
      .el-form-item.slider .el-form-item__content{
        display: flex;
        span{
          margin-left: 12px;
          font-size: 13px;
        }
      }
       .el-slider, .el-slider__runway{
          width: 220px;
        }
    }
  }
</style>
